<script lang="ts" setup>
import RowItemButton, { RowItemButtonProps } from '@/molecules/RowItemButton.vue';
import BaseCheckbox from '@/atoms/BaseCheckbox.vue';
import BaseToggle from '@/atoms/BaseToggle.vue';
import { computed } from 'vue';

const modelValue = defineModel<string[]>();

const props = defineProps<
  RowItemButtonProps & {
    value: string;
    initialChecked?: boolean;
    type: 'default' | 'toggle';
  }
>();
const isChecked = computed({
  get: () => modelValue.value?.includes(props.value) ?? false,
  set: (checked: boolean) => {
    const values = modelValue.value ?? [];

    if (checked) {
      if (!values.includes(props.value)) {
        modelValue.value = [...values, props.value];
      }
    } else {
      modelValue.value = values.filter((v) => v !== props.value);
    }
  },
});
</script>

<template>
  <RowItemButton
    v-bind="props"
    :selected="type === 'default' && isChecked"
    @click="isChecked = !isChecked"
  >
    <BaseCheckbox
      v-if="type === 'default'"
      :id="String(props.id)"
      v-model="isChecked"
      :initial-value="initialChecked"
      color-mode="on-brand"
    />
    <BaseToggle
      v-else
      :id="props.id"
      v-model="isChecked"
      :initial-value="initialChecked"
      color-mode="on-brand"
    />
  </RowItemButton>
</template>
